import React from 'react';

import { useDoc } from '../../hooks/useDoc';
import { FormBase } from '../Interface';
import DocumentPage from './DocumentPage';
import DocumentReports from './DocumentReports';

export const DocumentMain = ({ docTypeId }) => {
  const docState = useDoc({ docTypeId });

  return (
    <FormBase
      name="Document"
      leftPanelContent={<DocumentPage docState={docState} />}
      rightPanelContent={!docState.loading && <DocumentReports docState={docState} />}
    ></FormBase>
  );
};
